// extracted by mini-css-extract-plugin
export default {"footer":"DownloadSDKModal_footer__ooSEN","flexCenter":"DownloadSDKModal_flexCenter__LRg3P"};